import { Tab, Tabs, Box, MenuItem, Select, useMediaQuery } from '@mui/material';
import { useState } from 'react';

interface Day {
  label: string;
}

interface TabsBlockProps {
  value: number;
  labels: string[];
  selectedDay?: string;
  days: Day[];
  isAdaptive?: boolean;
  handleClick: (event: React.SyntheticEvent, newValue: number) => void;
  handleSelect?: (label: string, index: number) => void;
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const TabsBlock: React.FC<TabsBlockProps> = ({
  value,
  labels,
  selectedDay,
  days,
  isAdaptive,
  handleClick,
  handleSelect,
}) => {
  const xxs = useMediaQuery('(max-width: 373px)');
  const [mainValue, setMainValue] = useState<string>('');

  const handleSelectItem = (value: Day, valueIndex: number) => {
    setMainValue(value.label);

    if (handleSelect) {
      handleSelect(value.label, valueIndex);
    }
  };

  return (
    <>
      {xxs ? (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            zIndex: 5,
            fontFamily: 'Inter',
          }}>
          <Select
            className="swiper-no-swiping bg-[#f8f9fb] dark:bg-blue-darkMode-30 shadow-md"
            SelectDisplayProps={{
              style: {
                display: 'flex',
                alignItems: 'center',
                fontSize: '12px',
                lineHeight: '12px',
                justifyContent: 'center',
                color: 'transparent',
                minWidth: '34px',
                maxWidth: '34px',
                minHeight: '34px',
                height: '34px',
                boxShadow: '0 0 6px 2px rgba(0,0,0,.1)',
                fontWeight: 500,
                position: 'relative',
                padding: 0,
              },
            }}
            MenuProps={{
              PaperProps: {
                className: 'bg-white dark:bg-blue-darkMode-30',
              },
            }}
            IconComponent={() => (
              <Box
                sx={{
                  pointerEvents: 'none',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                }}
                component={'div'}>
                {mainValue ? (
                  <span className="text-[12px] dark:text-white uppercase">{mainValue}</span>
                ) : (
                  <span className="text-[12px] dark:text-white uppercase">
                    {'<CalendarIcon className="stroke-white" />'}
                  </span>
                )}
              </Box>
            )}
            label="Days">
            {days?.map((value, valueIndex) => (
              <MenuItem
                key={value.label}
                className="dark:bg-blue-darkMode-30 flex dark:text-white"
                sx={{
                  fontSize: '10px',
                  minHeight: '24px !important',
                  padding: '0 8px',
                  fontWeight: 500,
                  justifyContent: 'center',
                }}
                value={value.label}
                onClick={() => {
                  handleSelectItem(value, valueIndex);
                }}>
                <span className="uppercase">{value.label}</span>
              </MenuItem>
            ))}
          </Select>
        </Box>
      ) : (
        <Box sx={{ maxHeight: '40px' }}>
          <Tabs
            value={value}
            onChange={handleClick}
            aria-label="basic tabs example"
            className="!text-white"
            sx={{
              maxHeight: '40px !important',
              paddingInline: '3px',
              display: 'flex',
              overflow: 'visible',
              alignItems: 'center',
              gap: '1px',
              '.MuiTab-root': {
                width: 'min-content',
                display: 'flex',
                whiteSpace: 'nowrap',
                py: 0,
                px: '10px',
                fontFamily: 'Inter',
                fontWeight: '500',
                borderRadius: '8px',
                '&:hover': {
                  backgroundColor: '#f6f9ff',
                },
              },
              '& .Mui-selected': {
                border: '1px solid #fff',
                backgroundColor: '#F0F4FF',
                borderRadius: '8px',
                boxShadow: '0px 4px 12px #0000001A',
                color: '#000000 !important',
                textTransform: 'uppercase !important',
              },

              '& .css-bewcto-MuiButtonBase-root-MuiTab-root': {
                minWidth: '40px',
                minHeight: '40px',
                maxHeight: '40px',
              },
              '.MuiTabs-flexContainer': {
                marginTop: '-10px',
                paddingInline: '5px',
                gap: '4px',
              },
              '& .MuiTabs-scroller': {
                overflow: 'visible !important',
              },
            }}
            TabIndicatorProps={{
              style: {
                height: '24px',
                marginBlock: '3px',
                zIndex: -1,
                borderRadius: '5px',
                boxShadow: '0px 2px 2px #00000029',
              },
            }}>
            {labels.map((el, i) => (
              <Tab
                className={`${value === i ? '' : ''}  ${
                  i === labels.length - 1
                    ? '!min-w-[60px] !max-w-[60px] custom750:!min-w-[70px] custom750:!max-w-[70px]'
                    : '!min-w-[30px] max-w-[30px] custom750:!min-w-[41px] custom750:!max-w-[41px] '
                } !min-h-[35px] max-h-[35px] custom750:!min-h-[40px] !text-black-50 dark:!text-white-50 custom750:!max-h-[40px] !text-[12px]
           `}
                key={el}
                label={el}
                {...a11yProps(i)}
              />
            ))}
          </Tabs>
        </Box>
      )}
    </>
  );
};

export default TabsBlock;
